// @flow

import { type PendingIncomingPayment } from './types';

function getCipCode(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['cip_code'];
}

export function getSafeCipCode(incomingPayment: PendingIncomingPayment): string {
  const cipCode = getCipCode(incomingPayment);
  if (!cipCode)
    throw new Error('getSafeCipCode - there is no cip_code in the incoming payment');
  return cipCode;
}
